import { WEB_URL } from "../libs/config";

export const getStaticFileUrl = (path: string) =>
  `${WEB_URL}/static-files/${path}`;
